/**
 * in this module there are all the related functions for:
 *  - initialize the layer
 *  - add the layer to the map
 *  - initialize the datepicker
 */

/**
 * import modules
 */
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import functions from '../common/functions'
import map from '../common/map'
import overlay from '../common/overlay'

/**
 * global vars
 */

let invfeatlayer
var pageconfig = JSON.parse($('#pageconfig').val())
/**
 * create the parkmap layer
 */

let initInvLayer = () => {
  /**
   * get the settings from the functions module
   * update the vars accordingly
   */
  if (functions.getLayerList('invmap') === '') {return}

  /**
   * get resolutions from scale
   */

  // final resolutions array
  const resolutions = []
  // temp scale array
  const scaleArray = []
  // scales array from fixed.json
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  /**
   * get the extent of the visible map
   */
   //let layerinfo = pageconfig.layers.find(el => el.layers === "invmap")
     //this wont work on ie11 so need to use function below 

  var layerinfo = functions.altFind(pageconfig.layers, function(e) {
    return e.layers === "invmap"
  })
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]

  // INVMAP feature layer
  invfeatlayer = new TileLayer({
    // this extent limit the visible map
    name: 'invmap',
    className: 'featlayer',
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {
        'LAYERS': functions.getLayerList('invmap'),
        MYORDERS: $('#invfeatclick').val(),
        format: 'image/png'
      },
      ratio: 1,
      gutter: 40,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700',
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })

/**
 * end let initInvLayer = (getFixed, settings) => {
 */
}

/**
 * update the parkmap layer parameters
 */

const updateInvLayerParams = () => {
  /**
   * hide the layer
   */
  if (functions.getLayerList('invmap') === '') {return}

  invfeatlayer.setVisible(false)

  /**
   * if the visible restriction array is empty stop and return
   */
  let sOrderSel =  $('#invfeatclick').val()
  if (sOrderSel === '') {
    return
  }

  /**
   * update the restrictions to dipslay
   * refresh the source
   * show the layer
   */

  invfeatlayer.getSource().getParams().MYORDERS = sOrderSel
  invfeatlayer.getSource().refresh()
  invfeatlayer.setVisible(true)
  map.getMapTab()
/**
 * end const updateInvLayerParams = (sOrderSel) => {
 */
}

/**
 * remove the whole invmap layer
 */

$('#invlayerSwitch').on('click', function () {
  /**
   * assign this to the variable $this
   */

  let $this = $(this)

  /**
   * hide the popup
   */

  overlay.overlay.setPosition(undefined)

  /**
   * check if the value is on
   * change the value to off
   * remove the check class and apply the times class
   * remove the invfeatlayer
   * hide the invmap legend
   */

  if ($this.val() === 'on') {
    $this.val('off')
    $this.removeClass('fa-check').addClass('fa-times')
    map.getMap().removeLayer(invfeatlayer)
    $('#invlegend').hide()
  }

  /**
   * check if the value is off
   * change the value to on
   * remove the times class and apply the check class
   * add the invfeatlayer
   * show the invmap legend
   */

  else {
    $this.val('on')
    $this.removeClass('fa-times').addClass('fa-check')
    map.getMap().addLayer(invfeatlayer)
    invfeatlayer.setZIndex(1)
    $('#invlegend').css('display', 'flex')
  }

/**
 * end $('#invlayerSwitch').on('click', function () {
 */
})

/**
 * export the layers
 */

const invlayer = () => {
  return invfeatlayer
}

/**
 * export the addlayer
 */

const addlayer = () => {
  if (functions.getLayerList('invmap') === '') {return}
  map.getMap().addLayer(invfeatlayer)
  invfeatlayer.setZIndex(1)
}

/**
 * EXPORT
 */

export default {
  initInvLayer,
  addlayer,
  invlayer,
  updateInvLayerParams
}
